import React from "react";
import "./Tile.css";

export default function Tile({ content }) {
  return (
    <div className="tile">
      <div className="tile-body">{content}</div>
    </div>
  );
}
